import { makeSurfaceToken, makeInteractiveSurfaceToken, shadeColorForInteraction } from '@utils/css';
import { colors, staticColors } from './colors.js';

const primary = makeInteractiveSurfaceToken("--primary-surface", {
  default: {
    background: staticColors.primary,
    color: staticColors.textInversed
  },
  hover: {
    background: shadeColorForInteraction(staticColors.primary, "hover"),
    color: staticColors.textInversed
  },
  active: {
    background: shadeColorForInteraction(staticColors.primary, "active"),
    color: staticColors.textInversed
  }
});
const accent = makeInteractiveSurfaceToken("--accent-surface", {
  default: {
    background: staticColors.accent,
    color: staticColors.textInversed
  },
  hover: {
    background: shadeColorForInteraction(staticColors.accent, "hover"),
    color: staticColors.textInversed
  },
  active: {
    background: shadeColorForInteraction(staticColors.accent, "active"),
    color: staticColors.textInversed
  }
});
const graphicalPrimary = primary.__extend("--primary-graphical-surface");
const graphicalAccent = accent.__extend("--accent-graphical-surface");
const publisher = makeSurfaceToken("--publisher-surface", {
  background: staticColors.publisher,
  color: staticColors.textInversed
});
const gray = {
  sim100: makeSurfaceToken("--gray-100-surface", {
    background: colors.gray.sim100,
    color: colors.text.inversed
  }),
  sim60: makeSurfaceToken("--gray-60-surface", {
    background: colors.gray.sim65,
    color: colors.text.inversed
  }),
  sim40: makeSurfaceToken("--gray-40-surface", {
    background: colors.gray.sim40,
    color: colors.text.inversed
  }),
  sim30: makeSurfaceToken("--gray-30-surface", {
    background: colors.gray.sim30,
    color: colors.text.inversed
  }),
  sim10: makeSurfaceToken("--gray-10-surface", {
    background: colors.gray.sim10,
    color: colors.text.primary
  }),
  sim06: makeSurfaceToken("--gray-6-surface", {
    background: colors.gray.sim06,
    color: colors.text.primary
  }),
  sim03: makeSurfaceToken("--gray-3-surface", {
    background: colors.gray.sim03,
    color: colors.text.primary
  }),
  sim02: makeSurfaceToken("--gray-2-surface", {
    background: colors.gray.sim02,
    color: colors.text.primary
  }),
  sim00: makeSurfaceToken("--gray-0-surface", {
    background: colors.gray.sim00,
    color: colors.text.primary
  })
};
const surfaces = {
  primary,
  accent,
  publisher,
  gray,
  graphicalPrimary,
  graphicalAccent,
  success: makeSurfaceToken("--success-surface", {
    background: "232 249 225",
    color: colors.text.primary
  }),
  warning: makeSurfaceToken("--warning-surface", {
    background: "255 242 209",
    color: colors.text.primary
  }),
  danger: makeSurfaceToken("--danger-surface", {
    background: "255 224 224",
    color: colors.text.primary
  }),
  graphicalSuccess: makeSurfaceToken("--graphical-sucess-surface", {
    background: colors.success,
    color: colors.text.inversed
  }),
  graphicalWarning: makeSurfaceToken("--graphical-warning-surface", {
    background: colors.warning,
    color: colors.text.inversed
  }),
  graphicalDanger: makeSurfaceToken("--graphical-danger-surface", {
    background: colors.danger,
    color: colors.text.inversed
  }),
  notification: makeSurfaceToken("--notification-surface", {
    background: colors.notification,
    color: colors.text.inversed
  }),
  info: makeSurfaceToken("--info-surface", {
    background: colors.info,
    color: colors.text.primary
  })
};

export { surfaces };
//# sourceMappingURL=surfaces.js.map
